import { type FC } from 'react'
import { observer } from 'mobx-react-lite'
import { type IDropdownItem } from 'shared/ui'

type IWidgetMultiSelectTriggerProps = {
  selectedItems: IDropdownItem[]
  prefix: string
}

export const WidgetMultiSelectTrigger: FC<IWidgetMultiSelectTriggerProps> = observer(
  ({ selectedItems, prefix }) => {
    prefix = prefix || 'values'

    if (!selectedItems.length) return <>select</>
    if (selectedItems.length === 1) return selectedItems[0].label

    return (
      <>
        {selectedItems.length} {prefix}
      </>
    )
  }
)
